"use client";

import { useUserRealmId } from "@easybiz/component-shared";
import { formatLocalAddresses } from "@easybiz/utils";
import { collection, getDocs, getFirestore, limit, query, where } from "firebase/firestore/lite";
import { useEffect, useState } from "react";

export default (locationName, search) => {
  const realmId = useUserRealmId();
  const [addresses, setAddresses] = useState(null);

  useEffect(() => {
    setAddresses(null);
    if (locationName && search && !isNaN(search)) {
      getDocs(
        query(
          collection(getFirestore(), `cities/${`${locationName}`.toLowerCase()}/addresses`.toLowerCase()),
          where("searchables", "array-contains", `${search}`.toLowerCase()),
          limit(5)
        )
      ).then((result) => setAddresses(formatLocalAddresses(result.docs)));
    }
  }, [realmId, locationName, search]);

  return addresses;
};
